import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import "core-js/modules/es.string.replace-all.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.map.js";
import "core-js/modules/esnext.iterator.some.js";
import { __decorate } from "tslib";
/* eslint-disable no-undef */
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
//import '../plugins/vuetify' //forse non necessario su ogni componente
import _ from "lodash";
import hideMobileKeyboardOnReturn from "../plugins/utils";
import ItemsCarousel from "./ItemsCarousel.vue";
import config from "@/config/custom-config";
let Frontali = class Frontali extends Vue {
  constructor() {
    super(...arguments);
    this.element = {
      title: "Forma",
      subtitle: "Scegli la forma frontale"
    };
    this.itemsType = "frontali";
    this.open = false;
    this.query = "";
    this.frontModelActive = null;
    this.selectedSize = null;
    this.animateSize = false;
    this.noSizeSelectedDialog = false;
    this.previousSize = "";
    this.showSunModelNotAvailable = false;
    this.activeElement = null;
    this.selectedType = [];
    this.scrolling = false;
    this.showLeftButton = false;
    this.showRightButton = true;
    this.scrollCounter = 0;
    this.frontTypeOptions = [{
      text: "Vista",
      id: "V"
    }, {
      text: "Sole",
      id: "S"
    }];
    this.macCount = 0;
    this.currentScrollPosition = 0;
    this.selectedDynamicFilterOptionKey = "";
  }
  mounted() {
    if (this.showDynamicFrontFilter && this.selectedDynamicFilterOptionKey === "") {
      this.selectedDynamicFilterOptionKey = "0";
    }
  }
  get marchio() {
    return this.$store.state.marchio;
  }
  set marchio(value) {
    this.$store.commit("setMarchio", value);
  }
  get config() {
    return config;
  }
  get activeModelCode() {
    this.activeElement = this.$store.state.configurator.frontale;
    const frontale = this.$store.state.configurator.frontale;
    if (frontale) {
      return frontale.ItemCode;
    } else {
      console.warn("frontale is null or undefined");
      return null;
    }
  }
  set activeModelCode(value) {
    if (value) {
      this.setFrontal(value);
    }
  }
  get btActive() {
    return this.$store.state.btActive;
  }
  set btActive(value) {
    this.$store.state.btActive = value;
  }
  get lineNames() {
    const uniqueLines = Array.from(new Set(this.itemsByType.map(item => item.U_THE_LINEA).filter(line => !!line)));
    return uniqueLines.map(line => {
      return {
        title: line,
        value: line
      };
    });
  }
  get dynamicFilterLabel() {
    const configured = String(this.config.frontali_dynamic_filter_label || "").trim();
    return configured !== "" ? configured : "Filtro";
  }
  get dynamicFilterField() {
    return String(this.config.frontali_dynamic_filter_field || "").trim();
  }
  get dynamicFilterOptions() {
    const raw = this.config.frontali_dynamic_filter_options;
    if (!Array.isArray(raw)) return [];
    return raw.map(opt => {
      var _opt$label, _opt$value, _opt$operator;
      return {
        label: String((_opt$label = opt === null || opt === void 0 ? void 0 : opt.label) !== null && _opt$label !== void 0 ? _opt$label : "").trim(),
        value: String((_opt$value = opt === null || opt === void 0 ? void 0 : opt.value) !== null && _opt$value !== void 0 ? _opt$value : "").trim(),
        operator: String((_opt$operator = opt === null || opt === void 0 ? void 0 : opt.operator) !== null && _opt$operator !== void 0 ? _opt$operator : "eq").toLowerCase() === "neq" ? "neq" : "eq"
      };
    }).filter(opt => opt.label !== "");
  }
  get dynamicFilterOptionItems() {
    return this.dynamicFilterOptions.map((opt, index) => ({
      id: String(index),
      text: opt.label
    }));
  }
  get showDynamicFrontFilter() {
    return !!this.config.frontali_dynamic_filter_enabled && this.dynamicFilterField !== "" && this.dynamicFilterOptionItems.length > 0;
  }
  get selectedDynamicFilterOption() {
    if (!this.showDynamicFrontFilter) return null;
    const fallback = this.dynamicFilterOptions[0] || null;
    const idx = Number(this.selectedDynamicFilterOptionKey);
    if (!Number.isInteger(idx) || idx < 0 || idx >= this.dynamicFilterOptions.length) {
      return fallback;
    }
    return this.dynamicFilterOptions[idx];
  }
  normalizeDynamicValue(value) {
    return String(value !== null && value !== void 0 ? value : "").trim().toUpperCase();
  }
  get selectedFrontType() {
    return this.$store.state.configurator.glassType;
  }
  set selectedFrontType(val) {
    this.$store.commit("configurator/setLensesType", val, {
      root: true
    });
    // Check whether the corresponding version in the new type is actually available
    // If not, reset the frontal model to null
    // If the selected model is sun, check whether the sun version is actually available
    if (val == "S") {
      const filtered = this.items.filter(i => {
        return i.U_THE_CUSMODEL == "C" && i.U_TIPO_VSP == "S";
      });
      // If the corresponding sun model is not found, show an error to the user and bring him back to sight models
      if (filtered.find(f => {
        return f.U_THE_MODELLO == this.frontale.U_THE_MODELLO.replaceAll("C", "SC");
      }) == undefined) {
        this.showSunModelNotAvailable = true;
        return;
      }
    }
    this.$store.commit("setLenteDx", null);
    this.$store.commit("setLenteSx", null);
    this.$store.commit("resetLentiVista");
    this.$store.commit("configurator/lenti/resetCfgLenteVistaDx");
    this.$store.commit("configurator/lenti/resetCfgLenteVistaSx");
    // this.$store.commit("resetRowNotes");
  }
  get itemSizesWithFormattedSize() {
    return this.itemSizes.map(item => ({
      ...item,
      formattedSize: `${item.size_eye}/${item.size_bridge}`
    }));
  }
  get formattedItemSizes() {
    return this.itemSizes.map(item => ({
      text: `${parseInt(item.size_eye, 10)}-${parseInt(item.size_bridge, 10)}`,
      id: item.id
    }));
  }
  get calibro() {
    const parsed = parseInt(this.$store.state.configurator.calibro);
    return isNaN(parsed) ? 0 : parsed;
  }
  get naso() {
    const parsed = parseInt(this.$store.state.configurator.naso);
    return isNaN(parsed) ? 0 : parsed;
  }
  get frontale() {
    return this.$store.state.configurator.frontale;
  }
  get user() {
    return this.$store.state.configurator.user.user;
  }
  get sizes() {
    return this.$store.state.configurator.frontali.itemsSizes;
  }
  get items() {
    // Get all items and sort them based on the number present after the "." character
    return this.$store.state.configurator.frontali.items.sort((a, b) => {
      // Sort by TYPE
      if (a.TYPE === 'TOP' && b.TYPE !== 'TOP') return -1;
      if (a.TYPE !== 'TOP' && b.TYPE === 'TOP') return 1;
      if (a.TYPE === 'NEW' && b.TYPE !== 'NEW') return -1;
      if (a.TYPE !== 'NEW' && b.TYPE === 'NEW') return 1;
      // If TYPE is the same, sort by ORDERING
      if (a.ORDERING && b.ORDERING) {
        return a.ORDERING - b.ORDERING;
      }
      // If ORDERING is null, sort by name
      const id1 = parseInt(a.U_THE_MODELLO.substring(a.U_THE_MODELLO.lastIndexOf(".")).replace(/\D/g, ""));
      const id2 = parseInt(b.U_THE_MODELLO.substring(b.U_THE_MODELLO.lastIndexOf(".")).replace(/\D/g, ""));
      if (id1 > id2) return -1;
      if (id1 < id2) return 1;
      return 0;
    });
  }
  get asianFitting() {
    return this.$store.state.configurator.asianFitting;
  }
  set asianFitting(af) {
    this.$store.commit("configurator/setAsianFitting", af);
  }
  get elementTitle() {
    return _.upperCase(this.element.title);
  }
  get filteredItems() {
    const searchQuery = String(this.query || "").trim().toLowerCase();
    const selectedBrand = this.marchio ? this.marchio.trim() : "";
    let items = this.itemsByType;
    if (searchQuery) {
      items = items.filter(item => {
        const model = String(item.U_THE_MODELLO || "").toLowerCase();
        const itemCode = String(item.ItemCode || "").toLowerCase();
        return model.includes(searchQuery) || itemCode.includes(searchQuery);
      });
    }
    if (selectedBrand) {
      items = items.filter(item => {
        return item.U_THE_LINEA === selectedBrand;
      });
    }
    if (this.showDynamicFrontFilter && this.selectedDynamicFilterOption) {
      const option = this.selectedDynamicFilterOption;
      const field = this.dynamicFilterField;
      const targetValue = this.normalizeDynamicValue(option.value);
      items = items.filter(item => {
        const itemValue = this.normalizeDynamicValue(item[field]);
        if (option.operator === "neq") {
          return itemValue !== targetValue;
        }
        return itemValue === targetValue;
      });
    }
    const order = this.config.frontali_order;
    if (order !== "asc" && order !== "desc") {
      return items;
    }
    return [...items].sort((a, b) => {
      var _a$ORDERING, _b$ORDERING;
      const compareByOrdering = ((_a$ORDERING = a.ORDERING) !== null && _a$ORDERING !== void 0 ? _a$ORDERING : 0) - ((_b$ORDERING = b.ORDERING) !== null && _b$ORDERING !== void 0 ? _b$ORDERING : 0);
      if (compareByOrdering !== 0) {
        return order === "asc" ? compareByOrdering : -compareByOrdering;
      }
      const compareByModel = String(a.U_THE_MODELLO || "").localeCompare(String(b.U_THE_MODELLO || ""), undefined, {
        numeric: true,
        sensitivity: "base"
      });
      return order === "asc" ? compareByModel : -compareByModel;
    });
  }
  get itemsByType() {
    if (!this.selectedFrontType) {
      return this.items;
    }
    return this.items.filter(item => {
      return item.U_TIPO_VSP === this.selectedFrontType;
    });
  }
  get itemsLoaded() {
    return this.$store.state.itemsLoaded;
  }
  set itemsLoaded(value) {
    if (this.items.length > 0) {
      this.$store.commit("setItemsLoaded", value);
    }
  }
  get itemSizes() {
    let front = this.frontale;
    if (front && this.sizes.length > 0) {
      return this.sizes.filter(function (s) {
        return s.U_THE_MODELLO == front.U_THE_MODELLO;
      });
    }
    return [];
  }
  get finitura() {
    return this.$store.state.finitura;
  }
  set finitura(f) {
    this.$store.commit("configurator", "setFinishing", f);
  }
  get asianFittingText() {
    return this.asianFitting ? "YES " + this.$t("message.Asian_fitting") : "NO " + this.$t("message.Asian_fitting");
  }
  selectSizeFromSizes() {
    const s = this.itemSizes.filter(is => {
      var _this$frontale;
      return is.ItemCode == ((_this$frontale = this.frontale) === null || _this$frontale === void 0 ? void 0 : _this$frontale.ItemCode) && parseInt(is.size_eye) == this.calibro && parseInt(is.size_bridge) == this.naso;
    });
    if (s.length > 0) {
      this.selectedSize = s[0].id;
    }
  }
  get line() {
    return this.$store.state.currentLine;
  }
  get filteredTemples() {
    return this.$store.state.filteredTemples;
  }
  async setFrontal(value) {
    if (value) {
      var _this$$store$state$co;
      const previousSubline = (_this$$store$state$co = this.$store.state.configurator.frontale) === null || _this$$store$state$co === void 0 ? void 0 : _this$$store$state$co.U_THE_SOTTOLINEA;
      const sublineChanged = previousSubline !== value.U_THE_SOTTOLINEA;
      this.$store.commit("setCurrentLine", value.U_THE_LINEA);
      this.$store.commit("configurator/setFrontal", value);
      await this.$store.dispatch("configurator/user/refreshClientEngravingConfigurations", {
        line: value.U_THE_LINEA,
        itemCode: value.ItemCode
      });
      // Preserve the current customization while moving between models of the
      // same subline. Defaults are restored only when compatibility changes.
      if (sublineChanged) {
        this.$store.commit("configurator/setTemplesMaterial", "PL");
        const frontColor = this.config.frontali_default_color_enabled !== false ? this.config.defaultFrontColor || "EP0001" : "";
        const templesColor = this.config.aste_default_color_enabled !== false ? this.config.defaultTemplesColor || "EP0001" : "";
        if (frontColor) await this.$store.dispatch("configurator/frontali/setColor", frontColor);else this.$store.commit("configurator/setColore", null);
        if (templesColor) await this.$store.dispatch("configurator/aste/setColor", templesColor);else this.$store.commit("configurator/setTemplesColor", null);
        const correspondingTemple = this.filteredTemples.find(t => {
          return templesColor && t.U_THE_COLORE == templesColor && t.misura == (this.$store.state.configurator.coloreAste ? this.$store.state.configurator.coloreAste.U_THE_LUNGASTA : "145");
        });
        if (templesColor && correspondingTemple) {
          this.$store.commit("configurator/setTemplesColor", correspondingTemple);
          this.$store.state.configurator.coloreAste = correspondingTemple;
        } else if (templesColor) {
          console.warn("No corresponding temple found for the selected color");
        }
        this.$store.commit("configurator/setFinishing", "S");
        if (!this.$store.state.configurator.finituraAste) {
          this.$store.commit("configurator/setTemplesFinishing", "S");
        }
      }
    }
    if (value.U_THE_LINEA == 'ULTEMATE') {
      // this.$store.state.configurator.coloreTerminale = 0xff5100;
      this.$store.commit('configurator/setColoreTerminale', 0xff5100);
    }
  }
  setSize(value) {
    this.$store.commit("configurator/setSize", value);
  }
  clearSize() {
    this.$store.commit("configurator/setSize", {
      size_eye: "",
      size_bridge: ""
    });
  }
  setAsianFitting(value) {
    this.$store.commit("configurator/setAsianFitting", value);
  }
  setSunLensesModel(value) {
    this.$store.commit("configurator/setSunLensesModel", value);
  }
  hideMobileKeyboardOnReturn(e) {
    hideMobileKeyboardOnReturn(e);
  }
  async setFrame(item) {
    await this.setFrontal(item);
    if (this.selectedSize) {
      this.selectedSize = null;
      this.clearSize();
    }
    if (item.U_THE_LINEA == "BT") {
      this.btActive = true;
    } else {
      this.btActive = false;
    }
  }
  tipoChanged(newVal) {
    this.setSunLensesModel(null);
    const currentBrandStillValid = this.lineNames.some(line => {
      return line.value === this.marchio;
    });
    if (!currentBrandStillValid) {
      this.marchio = "";
    }
    const m = this.filteredItems.filter(i => {
      return i.U_THE_MODELLO.replace("SC", "").replace("C", "") == this.frontale.U_THE_MODELLO.replace("SC", "").replace("C", "") && i.U_TIPO_VSP == newVal;
    });
    if (m.length > 0) {
      // this.setFrontal(m[0]);
      this.$store.state.configurator.frontale == m;
      this.activeModelCode = m[0];
    }
    if (m.length > 0 && this.calibro && this.naso) {
      const s = this.itemSizes.filter(is => {
        return is.ItemCode == m[0].ItemCode && parseInt(is.size_eye) == this.calibro && parseInt(is.size_bridge) == this.naso;
      });
      if (s.length > 0) {
        this.setSize(s[0]);
      }
    }
  }
  async onMarchioChanged(newVal) {
    if (newVal) {
      this.currentScrollPosition = 0;
      if (this.filteredItems.length > 0) {
        if (this.filteredItems && this.filteredItems.length > 0) {
          await this.setFrontal(this.filteredItems[0]); // Imposta il primo elemento se esiste
        } else {
          console.log("nessun modello filtrato");
        }
      } else {
        console.log("nessun modello filtrato");
      }
    } else if (this.filteredItems.length > 0) {
      await this.setFrontal(this.filteredItems[0]);
    }
  }
  onShowDynamicFrontFilterChanged() {
    if (this.showDynamicFrontFilter && this.selectedDynamicFilterOptionKey === "") {
      this.selectedDynamicFilterOptionKey = "0";
    }
    if (!this.showDynamicFrontFilter) {
      this.selectedDynamicFilterOptionKey = "";
    }
  }
  onDynamicFilterOptionItemsChanged() {
    if (!this.showDynamicFrontFilter) return;
    const currentIdx = Number(this.selectedDynamicFilterOptionKey);
    if (!Number.isInteger(currentIdx) || currentIdx < 0 || currentIdx >= this.dynamicFilterOptionItems.length) {
      this.selectedDynamicFilterOptionKey = "0";
    }
  }
  onSelectedSizeChanged(newVal) {
    let s = this.itemSizes.filter(s => {
      return s.id == newVal;
    });
    if (s.length > 0) {
      const foundSize = this.sizes.find(el => {
        var _this$frontale2;
        return el.U_THE_MODELLO == ((_this$frontale2 = this.frontale) === null || _this$frontale2 === void 0 ? void 0 : _this$frontale2.U_THE_MODELLO) && Number(el.size_eye) == this.calibro && Number(el.size_bridge) == this.naso;
      });
      this.previousSize = foundSize == undefined ? null : foundSize.id;
      this.setSize(s[0]);
      this.noSizeSelectedDialog = false;
    } else {
      this.clearSize();
    }
  }
  onRevealSettingChanged(newVal) {
    //add animation class to element
    let self = this;
    if (newVal == "frontSize") {
      this.animateSize = true;
      setTimeout(function () {
        self.animateSize = false;
        self.$emit("reset-setting-item");
      }, 2000);
    }
    if (newVal == "frontSize") {
      this.animateSize = true;
      setTimeout(function () {
        self.animateSize = false;
        self.$emit("reset-setting-item");
      }, 2000);
    }
  }
  onStepperChangeChanged(newVal) {
    if (newVal[0] == 1 && this.calibro == 0) {
      //change from step 1
      this.noSizeSelectedDialog = true;
    }
  }
  onCalibroChanged() {
    if (this.naso) {
      this.selectSizeFromSizes();
    }
  }
  onNasoChanged() {
    if (this.calibro) {
      this.selectSizeFromSizes();
    }
  }
  onItemSizesChanged() {
    if (this.calibro && this.naso) {
      this.selectSizeFromSizes();
    }
  }
};
__decorate([Prop({
  default: false
})], Frontali.prototype, "isOpen", void 0);
__decorate([Prop({
  default: false
})], Frontali.prototype, "revealSetting", void 0);
__decorate([Prop({
  default: false
})], Frontali.prototype, "darkTheme", void 0);
__decorate([Prop({
  default: false
})], Frontali.prototype, "expanded", void 0);
__decorate([Prop()], Frontali.prototype, "stepperChange", void 0);
__decorate([Prop()], Frontali.prototype, "defaultFrontalModel", void 0);
__decorate([Watch("selectedFrontType")], Frontali.prototype, "tipoChanged", null);
__decorate([Watch("marchio")], Frontali.prototype, "onMarchioChanged", null);
__decorate([Watch("showDynamicFrontFilter")], Frontali.prototype, "onShowDynamicFrontFilterChanged", null);
__decorate([Watch("dynamicFilterOptionItems")], Frontali.prototype, "onDynamicFilterOptionItemsChanged", null);
__decorate([Watch("selectedSize")], Frontali.prototype, "onSelectedSizeChanged", null);
__decorate([Watch("revealSetting")], Frontali.prototype, "onRevealSettingChanged", null);
__decorate([Watch("stepperChange")], Frontali.prototype, "onStepperChangeChanged", null);
__decorate([Watch("calibro")], Frontali.prototype, "onCalibroChanged", null);
__decorate([Watch("naso")], Frontali.prototype, "onNasoChanged", null);
__decorate([Watch("itemSizes")], Frontali.prototype, "onItemSizesChanged", null);
Frontali = __decorate([Component({
  components: {
    ItemsCarousel
  },
  filters: {
    capitalize: function (value) {
      return _.capitalize(value);
    }
  }
})], Frontali);
export default Frontali;